import { useCallback, useEffect, useState } from 'react';

import { parseMeetingReportSendState, type MeetingReportSendState } from '../lib/deliverables/meetingReportSend';
import { supabase } from '../lib/supabase';

/**
 * Whether a CR can leave, why not, and the subject of its mail — read from the one server
 * definition (`get_meeting_report_send_state`), the same one `send-cr-email` re-checks under lock.
 * Used by every surface that offers to send a CR (Travail, CRM sheet, chat CR block): none of them
 * composes the subject or decides « sendable » on its own (principe 11).
 */
export function useMeetingReportSendState(reportId: string | null) {
  const [state, setState] = useState<MeetingReportSendState | null>(null);
  const [error, setError] = useState<string | null>(null);

  const load = useCallback(async () => {
    if (!reportId) {
      setState(null);
      return;
    }
    const { data, error: rpcError } = await supabase.rpc('get_meeting_report_send_state', { p_report_id: reportId });
    if (rpcError) {
      setError("Impossible de lire l'état d'envoi de ce compte rendu.");
      setState(null);
      return;
    }
    setError(null);
    setState(parseMeetingReportSendState(data));
  }, [reportId]);

  useEffect(() => {
    void load();
  }, [load]);

  return { state, error, reload: load };
}
